<template>
	<div class="group-template" :id="mode+'allBetGroup'+filMarketList.eveid">
		<template v-if="filMarketList && filMarketList.od && Object.keys(filMarketList.od).length>0">
			<!-- Hot / HDP OU -->
			<template v-if="selected_Tab == betTab.hdpou.key || selected_Tab == betTab.hot.key">
				<!-- RB -->
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)" ></allBetHDP>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)" ></allBetHDP>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)" ></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<template v-if="selected_Tab == betTab.hot.key">
					<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)"></allBet1x2>
					<!-- Other Sports -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<!-- clash with L84 <allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(mlBetType)"></allBetML> -->
				</template>	

				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(atgBetType)"></allBetOU>

				<template v-if="selected_Tab == betTab.hot.key">
					<!-- OE -->
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetBTTS>
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetBTTS>
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetBTTS>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetOE>
					<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)" ></allBetTG>
					<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
					<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetCS>
					<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetCS>
					<allBetNOG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(nogBetType)"></allBetNOG>
				</template>
				<template v-if="selectedBettype.tmpltId == '8' || (open_RBMarket && selectedSport.tmpltId == '8')">
					<!-- Snooker -->
					<template v-if="selectedBettype.sprtId == 'N15' || (open_RBMarket && selectedSport.sprtId == 'N15')">
						<!-- <allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE> -->
					</template>
					<template v-else-if="selectedBettype.sprtId == 'N2' || (open_RBMarket && selectedSport.sprtId == 'N2')">
						<allBetLDS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hldsBetType)"> </allBetLDS>
						<allBetLDS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(aldsBetType)"> </allBetLDS>
						<allBetWD :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(wdBetType)"> </allBetWD>
					</template>
					<template v-else-if="selectedBettype.sprtId == 'N20' || (open_RBMarket && selectedSport.sprtId == 'N20')"> <!-- Esport -->
						<!-- Game 1 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType"></allBetOE>
						<!-- Game 2 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType"></allBetOE>
						<!-- Game 3 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType"></allBetOE>
						<!-- Game 4 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType"></allBetOE>
						<!-- Game 5 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType"></allBetOE>

					</template>

					
					<template v-else-if="selectedBettype.sprtId == 'N23' || (open_RBMarket && selectedSport.sprtId == 'N23')"> <!-- Esport -->
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htrBetType)"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atrBetType)"></allBetOU>

						<template v-for="(play_type,key ) in bbPlaytype">
						<!-- Game 1 -->
							<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(onex2BetType)"></allBet1x2>
							<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(hdpBetType)"></allBetHDP>
							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ouBetType)"></allBetOU>
							<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"></allBetOE>

							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(htrBetType)"></allBetOU>
							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(atrBetType)"></allBetOU>
						</template>

						
						<!-- Game 2 -->
					</template>

					<!-- N3, N12, N21, tennis,badminton,volleyball -->
					<!-- OS : Game HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType"></allBetOE>
					<!-- OS : Set HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType"></allBetOE>
					<!-- OS : Point HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType"></allBetOE>
					<!-- OS : 1st Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType"></allBetOE>
					<!-- OS : 2nd Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType"></allBetOE>
					<!-- OS : 3rd Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType"></allBetOE>
					<!-- OS : 4th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType"></allBetOE>
					<!-- OS : 5th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType"></allBetOE>
					<!-- OS : 6th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType"></allBetOE>
				</template>
				<template v-if="selectedBettype.tmpltId == '7'"> <!-- Esport -->
					<!-- Game 1 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType"></allBetOE>
					<!-- Game 2 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType"></allBetOE>
					<!-- Game 3 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType"></allBetOE>
					<!-- Game 4 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType"></allBetOE>
					<!-- Game 5 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType"></allBetOE>

				</template>
			</template>

			<!-- Goals -->
			<template v-else-if="selected_Tab == betTab.goals.key">
				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetBTTS>
				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetBTTS>
				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetBTTS>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetOE>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetOE>
				<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
				<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
				<allBetNOG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(nogBetType)"></allBetNOG>
				<allBet1x2tgou :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ouBetType)"></allBet1x2tgou>
				<allBet1x2btts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2bttsBetType)"></allBet1x2btts>
				<allBetoubtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(oubttsBetType)"></allBetoubtts>
			</template>

			<!-- Correct Score -->
			<template v-else-if="selected_Tab == betTab.cs.key">
				<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetCS>
				<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetCS>
			</template>

			<!-- FT -->
			<template v-else-if="selected_Tab == betTab.ft.key">
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" ></allBet1x2>
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atgBetType)"></allBetOU>

				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetBTTS>
				<allBetHTFT :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"  :bettyp="getRB(htftBetType)"></allBetHTFT>
				<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
				<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetCS>
				<!-- new bettype -->
				<allBetNOG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(nogBetType)"></allBetNOG>
				<allBet1x2tgou :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ouBetType)"></allBet1x2tgou>
				<allBet1x2btts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2bttsBetType)"></allBet1x2btts>
				<allBetouoe :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouoeBetType)"></allBetouoe>
				<allBetoubtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(oubttsBetType)"></allBetoubtts>
				<allBetOuFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouftsBetType)"></allBetOuFts>
				<allBet1x2Fts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ftsBetType)"></allBet1x2Fts>
				<allBetDbchOu :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchouBetType)"></allBetDbchOu>
				<allBetDbchBtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchbttsBetType)"></allBetDbchBtts>
				<allBetDbchFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchftsBetType)"></allBetDbchFts>
			</template>

			<!-- HT -->
			<template v-else-if="selected_Tab == betTab.ht.key">
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)" ></allBet1x2>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)" ></allBet1x2>
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetOE>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetOE>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
			
				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetBTTS>
				<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetBTTS>
				<allBetHTFT :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"  :bettyp="getRB(htftBetType)"></allBetHTFT>
				<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
				<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetCS>
				<allBetDBCH :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetDBCH>
				<allBetDBCH :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetDBCH>
				<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
			</template>

			<!-- Set HDP -->
			<template v-else-if="selected_Tab == betTab.sethdp.key">
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType"></allBetOE>

				<!-- OS : 1st Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType"></allBetOE>
				<!-- OS : 2nd Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType"></allBetOE>
				<!-- OS : 3rd Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType"></allBetOE>
				<!-- OS : 4th Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType"></allBetOE>
				<!-- OS : 5th Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType"></allBetOE>
				<!-- OS : 6th Set -->
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType"></allBetOE>
			</template>
			<!-- Game HDP -->
			<template v-else-if="selected_Tab == betTab.gamehdp.key">
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(mlBetType)"></allBetML>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(hdpBetType)" ></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(ouBetType)"
					:remove-market="removeFromMyMarket" :my-market="true">
				</allBetOU>
				<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType"></allBetOE>
			</template>

			<!-- Special -->
			<template v-else-if="selected_Tab == betTab.special.key">
				<!-- new bettype -->
				<allBetNOG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(nogBetType)"></allBetNOG>
				<allBet1x2tgou :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ouBetType)"></allBet1x2tgou>
				<allBet1x2btts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2bttsBetType)"></allBet1x2btts>
				<allBetouoe :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouoeBetType)"></allBetouoe>
				<allBetoubtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(oubttsBetType)"></allBetoubtts>
				<allBetOuFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouftsBetType)"></allBetOuFts>
				<allBet1x2Fts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ftsBetType)"></allBet1x2Fts>
				<allBetDbchOu :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchouBetType)"></allBetDbchOu>
				<allBetDbchBtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchbttsBetType)"></allBetDbchBtts>
				<allBetDbchFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchftsBetType)"></allBetDbchFts>
				
				<template v-for="(specialEvent) in sortSpecialEvents(filMarketList)">
					<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
					<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
					<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
					
					<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>

					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>

					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)" :is-special="true"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(mlBetType)" :is-special="true"></allBet1x2>
					
					<ftCS :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></ftCS>
					<ftCS :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></ftCS>

					<ftTG :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)" :is-special="true"></ftTG>
					<ftTG :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)" :is-special="true"></ftTG>

					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true">></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :is-special="true">></allBetDBCH>

					<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :is-special="true"></allBetOE>
					<!--htft :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType"  :bettyp="getRB(htftBetType)" :is-special="true"></htft-->
				</template>
			</template>

			<!-- Other Tab -->
			<template v-else-if="selected_Tab == betTab.others.key">
				<allBetCSH :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(cshBetType)" ></allBetCSH>
				<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twnBetType)" ></allBetTW>
				<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twfbBetType)" ></allBetTW>
				<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twehBetType)" ></allBetTW>
				<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twbhBetType)" ></allBetTW>
				<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tsbhBetType)" ></allBetTW>
				<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
				<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
				<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
				<allBetHMG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hmgBetType)" ></allBetHMG>
				<allBetHMG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hmg1x2BetType)" ></allBetHMG>
			</template>

			<!-- All -->
			<template v-else-if="selected_Tab == betTab.all.key">
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" ></allBet1x2>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)"></allBet1x2>
				<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)"></allBet1x2>
				<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)"></allBetML>

				<template v-if="selectedBettype.tmpltId == '1' || (open_RBMarket && selectedSport.tmpltId == '1')">
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(htgBetType)"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(atgBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetOE>
					<allBetHTFT :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"  :bettyp="getRB(htftBetType)"></allBetHTFT>
					<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetCS>
					<allBetCS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetCS>
					<allBetDBCH :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetDBCH>
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetBTTS>
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetBTTS>
					<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetBTTS>
					<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
					<allBetTG :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)"></allBetTG>
					<allBetCSH :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(cshBetType)" ></allBetCSH>
					<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twnBetType)" ></allBetTW>
					<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twfbBetType)" ></allBetTW>
					<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twehBetType)" ></allBetTW>
					<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(twbhBetType)" ></allBetTW>
					<allBetTW :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(tsbhBetType)" ></allBetTW>
					<allBetWM :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetWM>
					<allBetFLG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetFLG>
					<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
					<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
					<allBetH1X2 :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType" :bettyp="getRB(h1x2BetType)" ></allBetH1X2>
					<allBetHMG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hmgBetType)" ></allBetHMG>
					<allBetHMG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hmg1x2BetType)" ></allBetHMG>
					<!-- new bettype -->
					<allBetNOG :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(nogBetType)"></allBetNOG>
					<allBet1x2tgou :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ouBetType)"></allBet1x2tgou>
					<allBet1x2btts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2bttsBetType)"></allBet1x2btts>
					<allBetouoe :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouoeBetType)"></allBetouoe>
					<allBetoubtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(oubttsBetType)"></allBetoubtts>
					<allBetOuFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouftsBetType)"></allBetOuFts>
					<allBet1x2Fts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(onex2ftsBetType)"></allBet1x2Fts>
					<allBetDbchOu :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchouBetType)"></allBetDbchOu>
					<allBetDbchBtts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchbttsBetType)"></allBetDbchBtts>
					<allBetDbchFts :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(dbchftsBetType)"></allBetDbchFts>
				</template>
				<template v-else-if="selectedBettype.tmpltId == '8' || (open_RBMarket && selectedSport.tmpltId == '8')">
					<!-- OE -->
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstHtPlyType"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="SecondHtPlyType"></allBetOE>
					<!-- Snooker -->
					<template v-if="selectedBettype.sprtId == 'N15' || (open_RBMarket && selectedSport.sprtId == 'N15')">
						<!-- <allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetOE> -->
					</template>
					<template v-else-if="selectedBettype.sprtId == 'N2' || (open_RBMarket && selectedSport.sprtId == 'N2')">
						<allBetLDS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(hldsBetType)"> </allBetLDS>
						<allBetLDS :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(aldsBetType)"> </allBetLDS>
						<allBetWD :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(wdBetType)"> </allBetWD>
						<!-- Ending Game -->
						<allBetEg :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"></allBetEg>
					</template>
					<template v-else-if="selectedBettype.sprtId == 'N20' || (open_RBMarket && selectedSport.sprtId == 'N20')"> <!-- Esport -->
						<!-- Game 1 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType"></allBetOE>
						<!-- Game 2 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType"></allBetOE>
						<!-- Game 3 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType"></allBetOE>
						<!-- Game 4 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType"></allBetOE>
						<!-- Game 5 -->
						<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(mlBetType)"></allBetML>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType"></allBetOE>

					</template>

					<template v-else-if="selectedBettype.sprtId == 'N23' || (open_RBMarket && selectedSport.sprtId == 'N23')"> <!-- Esport -->

						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htrBetType)"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atrBetType)"></allBetOU>
						<allBetWM :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"  :bettyp="wmrBetType"></allBetWM>
						<template v-for="(play_type,key ) in bbPlaytype">
							<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(onex2BetType)"></allBet1x2>
							<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(hdpBetType)"></allBetHDP>
							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ouBetType)"></allBetOU>
							<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"></allBetOE>

							
							<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(rhtrBetType)"></allBetOU> -->
							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(htrBetType)"></allBetOU>
							<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ratrBetType)"></allBetOU> -->
							<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(atrBetType)"></allBetOU>

							<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"  :bettyp="exiBetType"></allBetBTTS>
							
							<allBetWM :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"  :bettyp="wmrBetType"></allBetWM>
						</template>
					</template>

					<!-- N3, N12, N21, tennis,badminton,volleyball -->
					<!-- OS : Game HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="gameHdpPlyType"></allBetOE>
					<!-- OS : Set HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="setHandicapPlyType"></allBetOE>
					<!-- OS : Point HDP -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="pointHdpPlyType"></allBetOE>
					<!-- OS : 1st Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="firstSetPlyType"></allBetOE>
					<!-- OS : 2nd Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="secondSetPlyType"></allBetOE>
					<!-- OS : 3rd Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="thirdSetPlyType"></allBetOE>
					<!-- OS : 4th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fourthSetPlyType"></allBetOE>
					<!-- OS : 5th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="fifthSetPlyType"></allBetOE>
					<!-- OS : 6th Set -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="sixthSetPlyType"></allBetOE>
				</template>
				<template v-if="selectedBettype.tmpltId == '7'"> <!-- Esport -->
					<!-- Game 1 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game1PlyType"></allBetOE>
					<!-- Game 2 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game2PlyType"></allBetOE>
					<!-- Game 3 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game3PlyType"></allBetOE>
					<!-- Game 4 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game4PlyType"></allBetOE>
					<!-- Game 5 -->
					<allBetML :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(mlBetType)"></allBetML>
					<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(hdpBetType)"></allBetHDP>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType" :bettyp="getRB(ouBetType)"></allBetOU>
					<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="game5PlyType"></allBetOE>

				</template>

				<template v-if="filMarketList.sp" v-for="(specialEvent, key) in sortSpecialEvents(filMarketList)">
					<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
					
					<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>

					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>

					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(mlBetType)" :is-special="true"></allBet1x2>
					<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(mlBetType)" :is-special="true"></allBet1x2>
					
					<ftCS :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></ftCS>
					<ftCS :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></ftCS>

					<ftTG :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(tgBetType)" :is-special="true"></ftTG>
					<ftTG :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(tgBetType)" :is-special="true"></ftTG> 

					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></allBetDBCH>
					<allBetDBCH :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :is-special="true"></allBetDBCH>

					<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetOE>
					<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></allBetOE>
					<!--htft :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(htftBetType)" :is-special="true"></htft-->
				</template>

			</template>

			<!-- Innings -->
			<template v-else-if="selected_Tab == betTab.innings.key">
				<template v-if="selectedBettype.sprtId == 'N23' || (open_RBMarket && selectedSport.sprtId == 'N23')"> <!-- Esport -->

					<allBetWM :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType"  :bettyp="wmrBetType"></allBetWM>
					<template v-for="(play_type,key ) in bbPlaytype">
						<allBet1x2 :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(onex2BetType)"></allBet1x2>
						<allBetHDP :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(hdpBetType)"></allBetHDP>
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ouBetType)"></allBetOU>
						<allBetOE :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"></allBetOE>

						
						<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(rhtrBetType)"></allBetOU> -->
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(htrBetType)"></allBetOU>
						<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ratrBetType)"></allBetOU> -->
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(atrBetType)"></allBetOU>

						<allBetBTTS :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"  :bettyp="exiBetType"></allBetBTTS>
						
						<allBetWM :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type"  :bettyp="wmrBetType"></allBetWM>
					</template>
				</template>

			</template>

			<!-- Teams -->
			<template v-else-if="selected_Tab == betTab.team.key">
				<template v-if="selectedBettype.sprtId == 'N23' || (open_RBMarket && selectedSport.sprtId == 'N23')"> <!-- Esport -->

					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(htrBetType)"></allBetOU>
					<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="ftPlyType" :bettyp="getRB(atrBetType)"></allBetOU>
					<template v-for="(play_type,key ) in bbPlaytype">
						
						<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(rhtrBetType)"></allBetOU> -->
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(htrBetType)"></allBetOU>
						<!-- <allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(ratrBetType)"></allBetOU> -->
						<allBetOU :mode="mode" :all-bet-event="filMarketList" :plytyp="play_type" :bettyp="getRB(atrBetType)"></allBetOU>

					</template>
				</template>

			</template>

			<!-- Booking -->
			<template v-else-if="selected_Tab == betTab.booking.key">
				<template v-if="selectedBettype.tmpltId == '1' || (open_RBMarket && selectedBettype.tmpltId == '1')"> 
					<template v-if="filMarketList.sp" v-for="(specialEvent, key) in sortSpecialEvents(filMarketList)">
						<!-- 1x2 -->
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<!-- HDP -->
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<!-- OU -->
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<!-- OE -->
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetOE>
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></allBetOE>
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :is-special="true"></allBetOE>
					</template>
				</template>
			</template>
			<!-- Corner -->
			<template v-else-if="selected_Tab == betTab.corner.key">
				<template v-if="selectedBettype.tmpltId == '1' || (open_RBMarket && selectedBettype.tmpltId == '1')"> 
					<template v-if="filMarketList.sp" v-for="(specialEvent, key) in sortSpecialEvents(filMarketList)">
						<!-- 1x2 -->
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<allBet1x2 :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(onex2BetType)" :is-special="true"></allBet1x2>
						<!-- HDP -->
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<allBetHDP :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(hdpBetType)" :is-special="true"></allBetHDP>
						<!-- OU -->
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<allBetOU :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :bettyp="getRB(ouBetType)" :is-special="true"></allBetOU>
						<!-- OE -->
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="ftPlyType" :is-special="true"></allBetOE>
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="firstHtPlyType" :is-special="true"></allBetOE>
						<allBetOE :mode="mode" :all-bet-event="specialEvent" :plytyp="SecondHtPlyType" :is-special="true"></allBetOE>
					</template>
				</template>
			</template>

		</template>
		<template v-else>
			<div data-v-21f17103="" class="load-data-wrap  column yb-flex-center empty">
				<div data-v-21f17103="" class="list_right_empty">
				<div data-v-21f17103="" class="img"></div>
				<span data-v-21f17103="">{{ lang.sportTableLang['SPORT_TABLE.MARKET_CLOSED'] }}</span>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import {
	mapGetters,
} from 'vuex'
import vueCookie from 'vue-cookie'

import DateFilter from '@/vue/filters/date'

import allBetTeamInfo from './all-bet-team-info'
import allBetHDP from './allBet-hdp'
import allBetOU from './allBet-ou'
import allBet1x2 from './allBet-1x2'
import allBetCS from './allBet-cs'
import allBetTG from './allBet-tg'

import allBetHTFT from './allBet-htft'
import allBetOE from './allBet-oe'
import allBetATG from './all-bet-atg'
import allBetHTG from './all-bet-htg'
import allBetBTTS from './allBet-btts'
import allBetDBCH from './allBet-dbch'
import allBetCSH from './allBet-csh'
import allBetTW from './allBet-tw'
import allBetWM from './allBet-wm'
import allBetFLG from './allBet-flg'
import allBetHMG from './allBet-hmg'
import allBetML from './allBet-ml'
import allBetLDS from './allBet-lds'

import allBetWD from './allBet-wd'

import ftCS from './fullTime-cs'
import ftTG from './fullTime-tg'
import allBetH1X2 from './all-bet-h1x2'

import allBetNOG from './allBet-nog'
import allBet1x2tgou from './all-bet-1x2tgou'
import allBet1x2btts from './all-bet-1x2btts'
import allBetouoe from './all-bet-ouoe'
import allBetoubtts from './all-bet-oubtts'
import allBetOuFts from './all-bet-oufts'
import allBet1x2Fts from './all-bet-1x2fts'
import allBetDbchOu from './all-bet-dbchou'
import allBetDbchBtts from './all-bet-dbchbtts'
import allBetDbchFts from './all-bet-dbchfts'
import allBetEg from './all-bet-eg'

import allBetMixin from '../../../mixins/allBet'

import EventBus from '@/vue/events/event-bus'

export default {
	mixins: [allBetMixin],
	props: {
		// selTab: null,
		betTab: null,
		mode: null,
	},
	components: {
		allBetTeamInfo,
		allBetHDP,
		allBetOU,
		allBet1x2,
		allBetCS,
		allBetTG,
		ftCS,
		ftTG,
		allBetDBCH,
		allBetOE,
		allBetHTFT,
		//allBetSpecial,
		allBetATG,
		allBetHTG,
		allBetBTTS,
		allBetWM,
		allBetTW,
		allBetCSH,
		allBetH1X2,
		allBetHMG,
		allBetML,
		allBetFLG,
		allBetLDS,
		allBetWD,
		allBet1x2tgou,
		allBet1x2btts,
		allBetNOG,
		allBetouoe,
		allBetoubtts,
		allBetOuFts,
		allBet1x2Fts,
		allBetDbchOu,
		allBetDbchBtts,
		allBetDbchFts,
		allBetEg,
	},
	watch: {
		firstEvent(){
			if(this.mode=='firstEvent'){
				this.mainMarketList = _.cloneDeep(this.$store.getters.firstEvent)
			}
		},
		sortedMatchEventList: {
			handler(value, oldVal) {
				this.mainMarketList = _.cloneDeep(value)
			},
			deep: true,
			immediate: true,
		}
	},
	computed: {
		...mapGetters([
			'eventAllBet',
			'selectedShow',
			'selectedBettype',
			'selectedSport',
			'selected_AllBetTab',
			// 'sortedMatchEventList',
			'firstEvent',
			'market',
			'selectedMarket',
			'open_RBMarket',
		]),
		selected_Tab: {
			get() {
				if(this.mode=='ab'){
					return this.$store.getters.selected_AllBetTab.ab;
				}else{
					return this.$store.getters.selected_AllBetTab.firstEvent;
				}
			}
		},
		filMarketList() {
			// filteredMainMarketList() {
			var eventAllBet = _.cloneDeep(this.mainMarketList)
			switch (this.selected_Tab) {
				case this.marketSelect.hdpou.key:
					eventAllBet = this.getHdpOUOdd(eventAllBet)
					break;
				case this.marketSelect.sethdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.sethdp.value);
					break;
				case this.marketSelect.gamehdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.gamehdp.value);
					break;
				case this.marketSelect.pointhdp.key:
					eventAllBet.od = _.pick(eventAllBet.od, this.marketSelect.pointhdp.value);
					break;
				case this.marketSelect.special.key:
					// eventAllBet.od = [];
					eventAllBet.od[this.ftPlyType] = _.pick(eventAllBet.od[this.ftPlyType], this.marketSelect.special.value);
					break;
				case this.betTab.corner.key:
					var prefixes = this.betTab.corner.value;
					var filteredSp = {};
					$.each(eventAllBet.sp, function (key, value) {
						const sbid = value.sbid;
						if (prefixes.some(prefix => sbid.startsWith(prefix))) {
						// if (sbid.startsWith("9a") || sbid.startsWith("22a")) {
							filteredSp[key] = value;
						}
					});
					eventAllBet.sp = filteredSp;
					break;
				case this.betTab.booking.key:
					var prefixes = this.betTab.booking.value;
					var filteredSp = {};
					$.each(eventAllBet.sp, function (key, value) {
						const sbid = value.sbid;
						if (prefixes.some(prefix => sbid.startsWith(prefix))) {
						// if (sbid.startsWith("10a") || sbid.startsWith("23a")) {
							filteredSp[key] = value;
						}
					});
					eventAllBet.sp = filteredSp;
					break;
				default:
				//nothing
			}

			return eventAllBet
		},
		sortedMatchEventList: {
			get() {
				this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
				return this.$store.getters.sortedMatchEventList
			},
			set(value) {
				// this.$store.commit('SPORT_SHOW_FAV_EVENTS', value)
				// EventBus.$emit('refreshOdd', true)
				// this.$store.dispatch('getSportOdds',{
				//   callback: ((res) => {
				//     this.refreshTimer()
				//     this.refreshScroll()
				//   }).bind(this)
				// })
			}
		},
	},
	data() {
		return {
			lang: window.lang,
			marketSelect: {
				hdpou: {
					key: 'hdpou',
					value: [1,8,2,9,4,11,32,33,46,47,48,49,80,81,82,83], //bettype in allbet mixin
					flag: true,
				},
				special: {
					key: 'special',
					// value: true,
					value: [57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73],
					flag: true,
				},
				others: {
					key: 'others',
					value: true,
					flag: true,
				},
				sethdp: {
					key: 'set',
					value: [3, 7, 8, 9, 10, 11, 12],
					flag: true,
				},
				gamehdp: {
					key: 'game',
					value: [6],
					flag: true,
				},
				pointhdp: {
					key: 'point',
					value: [4],
					flag: true,
				},
			},
			cloneEventAllBet: null,
			mainMarketList: null,
			showMyMarkets: false,
			showMainMarkets: true,
			allBetRefreshTimer: 60,
			allBetTimerId: null,
			myMarketList: null,
			//selectedMarket: null,
			token: window.token,
			OtherSportList: ['G1', 'N2', 'N3','N21', 'N12', 'N7', 'N14', 'N15', 'N19', 'N20'], //Bk, os, tennis,bad,snooker,
			bbPlaytype: null, 
		}
	},
	methods: {
		getRB(bt){
			if(bt==1 || bt==8){
				return this.filMarketList.rbstatus=='1'? '8':'1';
			}else if(bt==2 || bt==9){
				return this.filMarketList.rbstatus=='1'? '9':'2';
			}else if(bt==3 || bt==10){
				return this.filMarketList.rbstatus=='1'? '10':'3';
			}else if(bt==4 || bt==11){
				return this.filMarketList.rbstatus=='1'? '11':'4';
			}else if(bt==5 || bt==18){
				return this.filMarketList.rbstatus=='1'? '18':'5';
			}else if(bt==6 || bt==17){
				return this.filMarketList.rbstatus=='1'? '17':'6';
			}else if(bt==7 || bt==16){
				return this.filMarketList.rbstatus=='1'? '16':'7';
			}else if(bt==12 || bt==13){
				return this.filMarketList.rbstatus=='1'? '13':'12';
			}else if(bt==19 || bt==20){
				return this.filMarketList.rbstatus=='1'? '20':'19';
			}else if(bt==21 || bt==27){
				return this.filMarketList.rbstatus=='1'? '27':'21';
			}else if(bt==28 || bt==29){
				return this.filMarketList.rbstatus=='1'? '29':'28';
			}else if(bt==30 || bt==31){
				return this.filMarketList.rbstatus=='1'? '31':'30';
			}else if(bt==32 || bt==33){
				return this.filMarketList.rbstatus=='1'? '33':'32';	
			}else if(bt==34 || bt==35){
				return this.filMarketList.rbstatus=='1'? '35':'34';
			}else if(bt==36 || bt==37){
				return this.filMarketList.rbstatus=='1'? '37':'36';	
			}else if(bt==38 || bt==39){
				return this.filMarketList.rbstatus=='1'? '39':'38';
			}else if(bt==40 || bt==41){
				return this.filMarketList.rbstatus=='1'? '41':'40';	
			}else if(bt==42 || bt==43){
				return this.filMarketList.rbstatus=='1'? '43':'42';
			}else if(bt==44 || bt==45){
				return this.filMarketList.rbstatus=='1'? '45':'44';	
			}else if(bt==46 || bt==47){
				return this.filMarketList.rbstatus=='1'? '47':'46';
			}else if(bt==48 || bt==49){
				return this.filMarketList.rbstatus=='1'? '49':'48';	
			}else if(bt==50 || bt==51){
				return this.filMarketList.rbstatus=='1'? '51':'50';	
			}else if(bt==53 || bt==55){
				return this.filMarketList.rbstatus=='1'? '55':'53';
			}else if(bt==54 || bt==56){
				return this.filMarketList.rbstatus=='1'? '56':'54';	
			}else if(bt==57 || bt==58){
				return this.filMarketList.rbstatus=='1'? '58':'57';	
			}else if(bt==59 || bt==73){
				return this.filMarketList.rbstatus=='1'? '73':'59';	
			}else if(bt==60 || bt==61){
				return this.filMarketList.rbstatus=='1'? '61':'60';	
			}else if(bt==63 || bt==64){
				return this.filMarketList.rbstatus=='1'? '64':'63';	
			}else if(bt==65 || bt==66){
				return this.filMarketList.rbstatus=='1'? '66':'65';	
			}else if(bt==68 || bt==69){
				return this.filMarketList.rbstatus=='1'? '69':'68';	
			}else if(bt==70 || bt==71){
				return this.filMarketList.rbstatus=='1'? '71':'70';	
			}else if(bt==80 || bt==81){
				return this.filMarketList.rbstatus=='1'? '81':'80';
			}else if(bt==76 || bt==79){
				return this.filMarketList.rbstatus=='1'? '79':'76';
			}else if(bt==77 || bt==78){
				return this.filMarketList.rbstatus=='1'? '78':'77';
			}else if(bt==82 || bt==83){
				return this.filMarketList.rbstatus=='1'? '83':'82';
			}
			return bt;
		},
		rbdata() {
			return this.filMarketList.rbinfo
		},
		chkShow(sportId, betType, plyType) {
			if (sportId == 13) { // american football
				if (plyType == 1 && betType != 3 && betType != 10) {
					return false
				}
			} else if (sportId == 1) { // soccer 
				if (this.$store.getters.selectedShow != 4 && plyType == 1 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
					if (this.$store.getters.selectedShow == 3 && (betType == 4 || betType == 11)) {  // Full Time
					} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {  // single line
					} else {
						return false
					}
				} else if (this.$store.getters.selectedShow != 3 && plyType == 2 && (betType == 1 || betType == 2 || betType == 4 || betType == 8 || betType == 9 || betType == 11)) {
					if (this.$store.getters.selectedShow == 4 && (betType == 4 || betType == 11)) {  // Full Time
					} else if (this.$store.getters.selectedShow == 1 && (betType == 4 || betType == 11)) {  // single line
					} else {
						return false
					}
				}
			} else if (plyType == 1 || plyType == 3) {
				return false
			}
			return true
		},
		setToTop(e) {
			var selected = 0;
			var itemlist = $('.group-template');
			var len = $(itemlist).children().length;

			selected = $(e.target).closest(".template").index()
			jQuery($(itemlist).children().eq(0)).before(jQuery($(itemlist).children().eq(selected)));
			// $(".template div .main-handicap").click(function () {
			//   selected = $(this).index();
			//   jQuery($(itemlist).children().eq(0)).before(jQuery($(itemlist).children().eq(selected)));
			// });
		},
		closeAllBetForm() {
			this.$store.commit('SELECTED_ALLBET', false)
		},
		backToTop() {
			document.getElementById("more_div").scrollTop = "0";
		},
		countOddsType(marKetList) {
			var count = 0;

			function getOddsCount(event) {
				var odCount = 0
				for (var plytyp = 0; plytyp < Object.keys(event.od).length; plytyp++) {
					var plytypKey = Object.keys(event.od)[plytyp]
					for (var bettyp = 0; bettyp < Object.keys(event.od[plytypKey]).length; bettyp++) {
						var bettypKey = Object.keys(event.od[plytypKey])[bettyp]
						//hdp, ou count submatch
						if (_.indexOf([this.hdpBetType, this.ouBetType, this.rhdpBetType, this.rouBetType], bettypKey) >= 0) {
							odCount += Object.keys(event.od[plytypKey][bettypKey]).length
						} else {
							odCount += 1
						}
					}
				}
				return odCount
			}

			var getCount = getOddsCount.bind(this)
			count += getCount(marKetList)
			if (marKetList.sp) {
				for (var eventId = 0; eventId < Object.keys(marKetList.sp).length; eventId++) {
					var event = marKetList.sp[Object.keys(marKetList.sp)[eventId]]
					count += getCount(event)
				}
			}
			return count
		},
		syncMainMarket() {
			if (this.myMarketList) {
				if (this.myMarketList.od[this.ftPlyType]) {
					var ftBetTyp = _.pick(this.mainMarketList.od[this.ftPlyType], Object.keys(this.myMarketList.od[this.ftPlyType]))
					this.$set(this.myMarketList.od, this.ftPlyType, ftBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.ftPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.ftPlyType], Object.keys(this.myMarketList.od[this.ftPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.firstHtPlyType]) {
					var firstHtBetTyp = _.pick(this.mainMarketList.od[this.firstHtPlyType], Object.keys(this.myMarketList.od[this.firstHtPlyType]))
					this.$set(this.myMarketList.od, this.firstHtPlyType, firstHtBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.firstHtPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.firstHtPlyType], Object.keys(this.myMarketList.od[this.firstHtPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.setHandicapPlyType]) {
					var setHandicapBetTyp = _.pick(this.mainMarketList.od[this.setHandicapPlyType], Object.keys(this.myMarketList.od[this.setHandicapPlyType]))
					this.$set(this.myMarketList.od, this.setHandicapPlyType, setHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.setHandicapPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.setHandicapPlyType], Object.keys(this.myMarketList.od[this.setHandicapPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.pointHdpPlyType]) {
					var pointHandicapBetTyp = _.pick(this.mainMarketList.od[this.pointHdpPlyType], Object.keys(this.myMarketList.od[this.pointHdpPlyType]))
					this.$set(this.myMarketList.od, this.pointHdpPlyType, pointHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.pointHdpPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.pointHdpPlyType], Object.keys(this.myMarketList.od[this.pointHdpPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.iotPlyType]) {
					var iotBetTyp = _.pick(this.mainMarketList.od[this.iotPlyType], Object.keys(this.myMarketList.od[this.iotPlyType]))
					this.$set(this.myMarketList.od, this.iotPlyType, iotBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.iotPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.iotPlyType], Object.keys(this.myMarketList.od[this.iotPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.gameHdpPlyType]) {
					var gameHandicapBetTyp = _.pick(this.mainMarketList.od[this.gameHdpPlyType], Object.keys(this.myMarketList.od[this.gameHdpPlyType]))
					this.$set(this.myMarketList.od, this.gameHdpPlyType, gameHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.gameHdpPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.gameHdpPlyType], Object.keys(this.myMarketList.od[this.gameHdpPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.firstSetPlyType]) {
					var firstSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.firstSetPlyType], Object.keys(this.myMarketList.od[this.firstSetPlyType]))
					this.$set(this.myMarketList.od, this.firstSetPlyType, firstSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.firstSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.firstSetPlyType], Object.keys(this.myMarketList.od[this.firstSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.secondSetPlyType]) {
					var secondSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.secondSetPlyType], Object.keys(this.myMarketList.od[this.secondSetPlyType]))
					this.$set(this.myMarketList.od, this.secondSetPlyType, secondSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.secondSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.secondSetPlyType], Object.keys(this.myMarketList.od[this.secondSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.thirdSetPlyType]) {
					var thirdSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.thirdSetPlyType], Object.keys(this.myMarketList.od[this.thirdSetPlyType]))
					this.$set(this.myMarketList.od, this.thirdSetPlyType, thirdSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.thirdSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.thirdSetPlyType], Object.keys(this.myMarketList.od[this.thirdSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.fourthSetPlyType]) {
					var fourthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fourthSetPlyType], Object.keys(this.myMarketList.od[this.fourthSetPlyType]))
					this.$set(this.myMarketList.od, this.fourthSetPlyType, fourthSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.fourthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.fourthSetPlyType], Object.keys(this.myMarketList.od[this.fourthSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.fifthSetPlyType]) {
					var fifthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.fifthSetPlyType], Object.keys(this.myMarketList.od[this.fifthSetPlyType]))
					this.$set(this.myMarketList.od, this.fifthSetPlyType, fifthSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.fifthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.fifthSetPlyType], Object.keys(this.myMarketList.od[this.fifthSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.sixthSetPlyType]) {
					var sixthSetHandicapBetTyp = _.pick(this.mainMarketList.od[this.sixthSetPlyType], Object.keys(this.myMarketList.od[this.sixthSetPlyType]))
					this.$set(this.myMarketList.od, this.sixthSetPlyType, sixthSetHandicapBetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.sixthSetPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.sixthSetPlyType], Object.keys(this.myMarketList.od[this.sixthSetPlyType])[i])
					}
				}
				if (this.myMarketList.od[this.game1PlyType]) {
					var game1BetTyp = _.pick(this.mainMarketList.od[this.game1PlyType], Object.keys(this.myMarketList.od[this.game1PlyType]))
					this.$set(this.myMarketList.od, this.game1PlyType, game1BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.game1PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game1PlyType], Object.keys(this.myMarketList.od[this.game1PlyType])[i])
					}
				}
				if (this.myMarketList.od[this.game2PlyType]) {
					var game2BetTyp = _.pick(this.mainMarketList.od[this.game2PlyType], Object.keys(this.myMarketList.od[this.game2PlyType]))
					this.$set(this.myMarketList.od, this.game2PlyType, game2BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.game2PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game2PlyType], Object.keys(this.myMarketList.od[this.game2PlyType])[i])
					}
				}
				if (this.myMarketList.od[this.game3PlyType]) {
					var game3BetTyp = _.pick(this.mainMarketList.od[this.game3PlyType], Object.keys(this.myMarketList.od[this.game3PlyType]))
					this.$set(this.myMarketList.od, this.game3PlyType, game3BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.game3PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game3PlyType], Object.keys(this.myMarketList.od[this.game3PlyType])[i])
					}
				}
				if (this.myMarketList.od[this.game4PlyType]) {
					var game4BetTyp = _.pick(this.mainMarketList.od[this.game4PlyType], Object.keys(this.myMarketList.od[this.game4PlyType]))
					this.$set(this.myMarketList.od, this.game4PlyType, game4BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.game4PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game4PlyType], Object.keys(this.myMarketList.od[this.game4PlyType])[i])
					}
				}
				if (this.myMarketList.od[this.game5PlyType]) {
					var game5BetTyp = _.pick(this.mainMarketList.od[this.game5PlyType], Object.keys(this.myMarketList.od[this.game5PlyType]))
					this.$set(this.myMarketList.od, this.game5PlyType, game5BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.game5PlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.game5PlyType], Object.keys(this.myMarketList.od[this.game5PlyType])[i])
					}
				}
				if (this.myMarketList.od[this.SecondHtPlyType]) {
					var game5BetTyp = _.pick(this.mainMarketList.od[this.SecondHtPlyType], Object.keys(this.myMarketList.od[this.SecondHtPlyType]))
					this.$set(this.myMarketList.od, this.SecondHtPlyType, game5BetTyp)
					for (var i = Object.keys(this.myMarketList.od[this.SecondHtPlyType]).length - 1; i >= 0; i--) {
						this.$delete(this.mainMarketList.od[this.SecondHtPlyType], Object.keys(this.myMarketList.od[this.SecondHtPlyType])[i])
					}
				}
				
				if (this.myMarketList.sp) {
					for (let eveid = 0; eveid < Object.keys(this.myMarketList.sp).length; eveid++) {
						var specialEvent = this.myMarketList.sp[Object.keys(this.myMarketList.sp)[eveid]];
						for (var plytyp = Object.keys(specialEvent.od).length - 1; plytyp >= 0; plytyp--) {
							var plytypId = Object.keys(specialEvent.od)[plytyp]
							if (this.mainMarketList.sp && this.mainMarketList.sp[specialEvent.eveid] &&
								this.mainMarketList.sp[specialEvent.eveid].od[plytypId] && specialEvent.od[plytypId]
							) {
								var betTypList = _.pick(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], Object.keys(specialEvent.od[plytypId]))
								this.$set(this.myMarketList.sp[specialEvent.eveid].od, plytypId, betTypList)
								for (var bettyp = Object.keys(specialEvent.od[plytypId]).length - 1; bettyp >= 0; bettyp--) {
									this.$delete(this.mainMarketList.sp[specialEvent.eveid].od[plytypId], Object.keys(this.myMarketList.sp[specialEvent.eveid].od[plytypId])[bettyp])
								}
							}
						}
					}
				}
			}
		},
		updateFavCookie(plytyp, bettyp, isDelete, isSpecial = false) {
			var favCookie = {}
			if (vueCookie.get(window.compcode + '_fav')) {
				favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
				if (!isSpecial) {
					if (!favCookie[plytyp])
						favCookie[plytyp] = {}
					favCookie[plytyp][bettyp] = {}
					if (isDelete) {
						_.unset(favCookie[plytyp], [bettyp])
						if (Object.keys(favCookie[plytyp]).length == 0) {
							_.unset(favCookie, [plytyp])
						}
					}
				} else {
					if (!favCookie.sp)
						favCookie.sp = {}
					if (!favCookie.sp[isSpecial.eveid])
						favCookie.sp[isSpecial.eveid] = {}
					if (!favCookie.sp[isSpecial.eveid][plytyp])
						favCookie.sp[isSpecial.eveid][plytyp] = {}
					favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
					if (isDelete) {
						_.unset(favCookie.sp[isSpecial.eveid][plytyp], [bettyp])
						if (Object.keys(favCookie.sp[isSpecial.eveid][plytyp]).length == 0) {
							_.unset(favCookie.sp[isSpecial.eveid], [plytyp])
						}
						if (Object.keys(favCookie.sp[isSpecial.eveid]).length == 0) {
							_.unset(favCookie.sp, isSpecial.eveid)
						}
					}
				}
			} else {
				if (!isSpecial) {
					favCookie[plytyp] = {}
					favCookie[plytyp][bettyp] = {}
				} else {
					favCookie.sp = {}
					favCookie.sp[isSpecial.eveid] = {}
					favCookie.sp[isSpecial.eveid][plytyp] = {}
					favCookie.sp[isSpecial.eveid][plytyp][bettyp] = {}
				}
			}
			vueCookie.set(window.compcode + '_fav', JSON.stringify(favCookie))
		},
		getFavCookieMarket() {
			var favCookie = {}
			if (vueCookie.get(window.compcode + '_fav')) {
				favCookie = JSON.parse(vueCookie.get(window.compcode + '_fav'))
				for (var plytyp = Object.keys(favCookie).length - 1; plytyp >= 0; plytyp--) {
					var pt = Object.keys(favCookie)[plytyp]
					if (pt != 'sp') {
						for (var bettyp = Object.keys(favCookie[pt]).length - 1; bettyp >= 0; bettyp--) {
							var bt = Object.keys(favCookie[pt])[bettyp]
							if (this.$store.getters.sortedMatchEventList.od[pt]) {
								if (this.$store.getters.sortedMatchEventList.od[pt][bt]) {
									this.pickMarket(this.$store.getters.sortedMatchEventList, pt, bt)
								}
							}
						}
					} else {
						for (var eve = Object.keys(favCookie.sp).length - 1; eve >= 0; eve--) {
							var eveid = Object.keys(favCookie.sp)[eve]
							for (var plytyp = Object.keys(favCookie.sp[eveid]).length - 1; plytyp >= 0; plytyp--) {
								var pt = Object.keys(favCookie.sp[eveid])[plytyp]
								for (var bettyp = Object.keys(favCookie.sp[eveid][pt]).length - 1; bettyp >= 0; bettyp--) {
									var bt = Object.keys(favCookie.sp[eveid][pt])[bettyp]
									if (this.$store.getters.sortedMatchEventList.sp && this.$store.getters.sortedMatchEventList.sp[eveid]) {
										if (this.$store.getters.sortedMatchEventList.sp[eveid].od[pt]) {
											if (this.$store.getters.sortedMatchEventList.sp[eveid].od[pt][bt]) {
												this.pickMarket(this.$store.getters.sortedMatchEventList.sp[eveid], pt, bt, true)
											}
										}
									}
								}
							}
						}
					}
				}
			}
			return {}
		},
		pickMarket(market, plytyp, bettyp, isSpecial = false) {
			if (this.myMarketList) {
				if (!isSpecial) {
					if (!this.myMarketList.od[plytyp]) {
						this.$set(this.myMarketList.od, plytyp, {})
					}
					this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
				} else {
					!this.myMarketList.sp ? this.$set(this.myMarketList, 'sp', {}) : this.myMarketList.sp
					!this.myMarketList.sp[market.eveid] ? this.$set(this.myMarketList.sp, market.eveid, {}) : this.myMarketList.sp[market.eveid]
					//refresh special team info
					let copyMarket = _.cloneDeep(market)
					_.unset(copyMarket, 'od')
					_.assign(this.myMarketList.sp[market.eveid], copyMarket)

					!this.myMarketList.sp[market.eveid].od ? this.$set(this.myMarketList.sp[market.eveid], 'od', {}) : this.myMarketList.sp[market.eveid].od
					!this.myMarketList.sp[market.eveid].od[plytyp] ? this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {}) : this.myMarketList.sp[market.eveid].od[plytyp]
					this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
				}
			} else { //first pick
				this.myMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
				this.$set(this.myMarketList, 'od', {})
				this.$set(this.myMarketList, 'sp', {})
				if (!isSpecial) {
					this.$set(this.myMarketList.od, plytyp, {})
					this.$set(this.myMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
				} else {
					this.$set(this.myMarketList.sp, market.eveid, _.cloneDeep(market))
					this.$set(this.myMarketList.sp[market.eveid], 'od', {})
					this.$set(this.myMarketList.sp[market.eveid].od, plytyp, {})
					this.$set(this.myMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
				}
				this.showMyMarkets = true
			}
			!isSpecial ? this.updateFavCookie(plytyp, bettyp, false) : this.updateFavCookie(plytyp, bettyp, false, market)
			!isSpecial ? this.$delete(this.mainMarketList.od[plytyp], bettyp) : this.$delete(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp)
		},
		removeFromMyMarket(market, plytyp, bettyp, isSpecial = false) {
			if (!isSpecial) {
				this.$set(this.mainMarketList.od[plytyp], bettyp, market.od[plytyp][bettyp])
				if (Object.keys(this.myMarketList.od[plytyp]).length > 1)
					this.$delete(this.myMarketList.od[plytyp], bettyp)
				else
					this.$delete(this.myMarketList.od, plytyp)

				if (Object.keys(this.myMarketList.od).length == 0)
					this.myMarketList = null
			} else {
				this.$set(this.mainMarketList.sp[market.eveid].od[plytyp], bettyp, market.od[plytyp][bettyp])
				if (Object.keys(this.myMarketList.sp[market.eveid].od[plytyp]).length > 1)
					this.$delete(this.myMarketList.sp[market.eveid].od[plytyp], bettyp)
				else
					this.$delete(this.myMarketList.sp[market.eveid].od, plytyp)

				if (Object.keys(this.myMarketList.sp[market.eveid].od).length == 0)
					this.$delete(this.myMarketList.sp, market.eveid)
				if (Object.keys(this.myMarketList.sp).length == 0)
					this.$delete(this.myMarketList, 'sp')
			}
			//need to support special
			!isSpecial ? this.updateFavCookie(plytyp, bettyp, true) : this.updateFavCookie(plytyp, bettyp, true, market)
		},
		getHdpOUOdd(event) {
			if (event.od[this.ftPlyType])
				event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.firstHtPlyType])
				event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.setHandicapPlyType])
				event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.pointHandicapPlyType])
				event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.iotPlyType])
				event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.gameHdpPlyType])
				event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.firstSetPlyType])
				event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.secondSetPlyType])
				event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.thirdSetPlyType])
				event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.fourthSetPlyType])
				event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.fifthSetPlyType])
				event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.sixthSetPlyType])
				event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game1PlyType])
				event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game2PlyType])
				event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game3PlyType])
				event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game4PlyType])
				event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.game5PlyType])
				event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.marketSelect.hdpou.value);
			if (event.od[this.SecondHtPlyType])
				event.od[this.SecondHtPlyType] = _.pick(event.od[this.SecondHtPlyType], this.marketSelect.hdpou.value);
				
			return event
		},
		getScoreMarketOdd(event) {
			if (event.od[this.ftPlyType])
				event.od[this.ftPlyType] = _.pick(event.od[this.ftPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.firstHtPlyType])
				event.od[this.firstHtPlyType] = _.pick(event.od[this.firstHtPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.setHandicapPlyType])
				event.od[this.setHandicapPlyType] = _.pick(event.od[this.setHandicapPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.pointHandicapPlyType])
				event.od[this.pointHandicapPlyType] = _.pick(event.od[this.pointHandicapPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.iotPlyType])
				event.od[this.iotPlyType] = _.pick(event.od[this.iotPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.gameHdpPlyType])
				event.od[this.gameHdpPlyType] = _.pick(event.od[this.gameHdpPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.firstSetPlyType])
				event.od[this.firstSetPlyType] = _.pick(event.od[this.firstSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.secondSetPlyType])
				event.od[this.secondSetPlyType] = _.pick(event.od[this.secondSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.thirdSetPlyType])
				event.od[this.thirdSetPlyType] = _.pick(event.od[this.thirdSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.fourthSetPlyType])
				event.od[this.fourthSetPlyType] = _.pick(event.od[this.fourthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.fifthSetPlyType])
				event.od[this.fifthSetPlyType] = _.pick(event.od[this.fifthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.sixthSetPlyType])
				event.od[this.sixthSetPlyType] = _.pick(event.od[this.sixthSetPlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game1PlyType])
				event.od[this.game1PlyType] = _.pick(event.od[this.game1PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game2PlyType])
				event.od[this.game2PlyType] = _.pick(event.od[this.game2PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game3PlyType])
				event.od[this.game3PlyType] = _.pick(event.od[this.game3PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game4PlyType])
				event.od[this.game4PlyType] = _.pick(event.od[this.game4PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.game5PlyType])
				event.od[this.game5PlyType] = _.pick(event.od[this.game5PlyType], this.marketSelect.scrMarket.value);
			if (event.od[this.SecondHtPlyType])
				event.od[this.SecondHtPlyType] = _.pick(event.od[this.SecondHtPlyType], this.marketSelect.scrMarket.value);

			return event
		},
		chooseMarketType(market, id) {
			if (market.flag) {
				this.selectedMarket = market.key
			}
			this.switchAllBetTab(id)
		},
		sortSpecialEvents(specialEvents) {
			$.each(specialEvents.sp, function (key, value) {
				if(specialEvents.sp_rbinfo && specialEvents.sp_rbinfo[key]) {
					specialEvents.sp[key].sprbinfo = specialEvents.sp_rbinfo[key]
				}
			})
			return _.sortBy(specialEvents.sp, ['no'])
		},
		switchAllBetTab(id) {
			$('.moreBetTypeNav-Item').removeClass('active');
			$(id).addClass('active');
		},
	}, 
	beforeMount() {
		// this.allBetRefreshTimer = this.getMarketTimer(this.$store.getters.selectedMarket)
		// this.selectedMarket = this.market.allMarket.key
		if(this.mode=='firstEvent'){
			this.mainMarketList = _.cloneDeep(this.$store.getters.firstEvent)
		}else{
			// this.mainMarketList = _.cloneDeep(this.$store.getters.sortedEventList)
			this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)
		}
		this.bbPlaytype = [
		            this.first5InningsPlayType,
		            this.first3InningsPlayType,
			this.firstInningsPlayType,
			this.secondInningsPlayType,
			this.thirdInningsPlayType,
			this.fourthInningsPlayType,
			this.fifthInningsPlayType,
			this.sixthInningsPlayType,
			this.seventhInningsPlayType,
			this.eightthInningsPlayType,
			this.nineInningsPlayType,
			this.OTPlayType,
		]

		this.getFavCookieMarket()
	},
	updated() {
		if(this.$store.getters.rightBoardChange != null) {
			// console.log($('#firstEventallBetGroup'+this.$store.getters.rightBoardChange.eveid+' .c-bet-item'))
			$('#firstEventallBetGroup'+this.$store.getters.rightBoardChange.eveid+' .c-bet-item').removeClass('active');
			this.$store.getters.betForm.forEach(value => {
				var MID = value.uniqueId;
				var prt = $('#firstEventallBetGroup'+this.$store.getters.rightBoardChange.eveid+' #'+MID)
				if(prt.length > 0) {
					prt.closest('.c-bet-item').addClass('active')
				}
			})
			this.$store.commit('RIGHT_BOARD_CHG', null)
		}
	},
	destroyed() {
		// this.clearAllBetTimer()
	},
}
</script>

<style lang="scss">
@import "~@/styles/base/global";
// @import "~@/styles/sport/allBet/allBet";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet.vue